<script setup lang="ts">
import {ICellRendererParams} from "ag-grid-community";
import NamaIcon from "@/components/icons/NamaIcon.vue";
import EditScreenGridHandler from "@/utils/common/EditScreenGridHandler.ts";
import {computed} from "vue";
import ObjectChecker from "@/utils/common/ObjectChecker.ts";
import CommonConstants from "@/utils/constants/CommonConstants.ts";
import Translator from "@/utils/common/Translator.ts";
import PlaceUtils from "@/utils/common/PlaceUtils.ts";

const props = defineProps<{ params: ICellRendererParams }>();
const handler: EditScreenGridHandler = props.params["handler"]()
const colId = props.params["columnId"];

const isColumnDisabled = (): boolean => {
  return handler.presenter.isColumnDisabled(props.params.data.id, handler.gridId, colId)
}

const link = computed<string | null | undefined>(() => props.params?.value);


const getActualLink = computed(() => {
  return PlaceUtils.normalizedGUILink(link.value);
})

const getDisplayedText = computed<string>(() => {
  const url = link.value;
  if (ObjectChecker.isEmptyOrNull(url))
    return "";
  let title = url;
  const separator = CommonConstants.URL_TITLE_SEPARATOR;
  if (url.includes(separator)) {
    title = url.substring(0, url.indexOf(separator))
    const res = "res:";
    if (title.startsWith(res))
      title = Translator.translateId(title.substring(res.length))
  }
  return title;
})

function onLinkClicked(e: MouseEvent): void {
  const linkValue = getActualLink.value;
  if (!linkValue)
    return;
  if (isColumnDisabled())
    return;
  window.open(linkValue, '_blank');
  e.preventDefault();
}
</script>

<template>
  <div class="tw-flex tw-w-full tw-items-center tw-h-full tw-gap-1 tw-justify-between">
    <span v-text="getDisplayedText" class="tw-overflow-hidden tw-text-primary-light dark:tw-text-primary-dark"/>
    <a :href="getActualLink" target="_blank" @click.stop="onLinkClicked" :title="getDisplayedText">
      <q-avatar
        :class="{'nama-elevated-hover tw-cursor-pointer':!isColumnDisabled()}"
        class="nama-avatar-hover tw-size-7 tw-cursor-pointer" square>
        <NamaIcon default-icon="nm-link" class="tw-size-4" :class="[isColumnDisabled()?'icon-disabled':'active-primary']"/>
      </q-avatar>
    </a>
  </div>
</template>
